import { ServiceNamesLookup } from '@avicennapharmacy/managemymeds-shared';

export const MIN_SEARCH_LENGTH = 3;
export const SEARCH_DEBOUNCE_WAIT = 1000;

export type Option<T> = {
  label: string;
  value: T;
};

export const multiLineString = (properties: string[]) => properties.filter(Boolean).join('\n');

export const subServiceIdMap = (
  serviceNameId: string,
  subServiceNameId: string,
  serviceNamesLookup: ServiceNamesLookup,
) => {
  const subServiceName = serviceNamesLookup[serviceNameId].subs[subServiceNameId].name;

  return subServiceName.length ? subServiceName : '';
};
